import { useQuery } from '@tanstack/react-query';
import decodeJson from '@seccon/shared/utils/decodeJson';
import ApiError from '@seccon/shared/utils/ApiError';

const fetchSessionInfo = (sessionId) => fetch(`/personnelComparisonTool/${ sessionId }/sessionInfo`).then(decodeJson)
  .catch(({ body }) => {
    throw new ApiError(
      body ? `Error: ${ body }` : 'Could not load view only differences toggle value'
    );
  });
function processSessionInfo (response) {
  return response?.verifyRecordsViewOnlyDiffs;
}
const useSessionInfo = (sessionId) => useQuery({
  queryKey: ['sessionInfo', sessionId],
  queryFn: () => fetchSessionInfo(sessionId),
  enabled: !!sessionId,
  staleTime: 0,
  select: processSessionInfo,
  refetchOnWindowFocus: false
})

export default useSessionInfo;
